import { FGEmpty, FGTextInput, FieldGroup } from "nsitools-react";
import * as React from "react";
import * as Yup from "yup";

import { PersonApi, WebUserApi } from "../../../../api";
import { useAuth } from "../../../../contexts";
import { useApiService, useCrudApi, useTl } from "../../../../hooks";
import { ETLCodes } from "../../../../locales";
import { DrupalFormGenerator } from "../../../common/DrupalFormGenerator";

export interface IDrupalProfileChangeEmailTabProps {}

export const DrupalProfileChangeEmailTab: React.FunctionComponent<IDrupalProfileChangeEmailTabProps> = () => {
  const { t } = useTl();
  const api = useApiService(WebUserApi);
  const { user } = useAuth();

  const { data, loading, saving, saveItem } = useCrudApi(
    {
      getApiFn: async () => {
        const email = await api.getEmail(user.userId);
        return { email: email, newEmail1: "", newEmail2: "" };
      },
      saveApiFn: (d) => api.changeEmail(d.newEmail1, user.userId),
      deleteApiFn: () => {},
    },
    []
  );
  const validationSchema = React.useMemo(() => {
    return Yup.object().shape({
      newEmail1: Yup.string().nullable().required(t(ETLCodes.Required)),
      newEmail2: Yup.string()
        .nullable()
        .required(t(ETLCodes.Required))
        .test("is-equal", t(ETLCodes.EmailsMustMatch), async function (value) {
          return value === this.parent.newEmail1;
        }),
    });
  }, [t]);
  return (
    <>
      <DrupalFormGenerator
        initialValues={data}
        onSubmit={saveItem}
        editMode={true}
        loading={loading}
        validationSchema={validationSchema}
        saving={saving}
        minLabelWidth={280}
      >
        <FieldGroup columns={2}>
          <FieldGroup columns={1}>
            <FGTextInput name="email" label={t(ETLCodes.CurrentEmail)} readonly />
            <FGTextInput name="newEmail1" label={t(ETLCodes.NewEmail)} />
            <FGTextInput name="newEmail2" label={t(ETLCodes.NewEmailConfirmation)} />
          </FieldGroup>
          <FGEmpty />
        </FieldGroup>
      </DrupalFormGenerator>
    </>
  );
};
